import { chatRoomsPath } from "@circle-react/helpers/urlHelpers";
import { useLocation } from "@tanstack/react-router";
import { useLayoutEffect, useRef } from "react";

import { useAvatarConversationPanelStore } from "../useAvatarConversationPanelStore";

// Navigating away from fullscreen reveals the destination, and Messages has
// its own avatar chat UI.
export const useAvatarPanelRouteState = (): void => {
  const pathname = useLocation({ select: location => location.pathname });
  const previousPathnameRef = useRef(pathname);

  useLayoutEffect(() => {
    const { panelState, closePanel, setPanelState } =
      useAvatarConversationPanelStore.getState();
    const hasNavigated = previousPathnameRef.current !== pathname;
    previousPathnameRef.current = pathname;

    if (pathname.startsWith(chatRoomsPath())) {
      closePanel();
      return;
    }

    if (hasNavigated && panelState === "fullscreen") {
      setPanelState("default");
    }
  }, [pathname]);
};
